var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.375c.266 0 .503.168.59.42L14.8 8.148l6.724.137a.625.625 0 0 1 .365 1.123l-5.36 4.063 1.948 6.438a.625.625 0 0 1-.955.694l-5.52-3.842-5.522 3.842a.625.625 0 0 1-.955-.694l1.948-6.438-5.36-4.063a.625.625 0 0 1 .365-1.123L9.2 8.148l2.209-6.353a.625.625 0 0 1 .59-.42Zm0 2.529-1.76 5.065a.625.625 0 0 1-.578.42l-5.362.11 4.273 3.239a.625.625 0 0 1 .221.68L7.241 18.55l4.402-3.063c.215-.15.5-.15.714 0l4.402 3.063-1.553-5.133a.625.625 0 0 1 .22-.679l4.274-3.24-5.361-.11a.625.625 0 0 1-.578-.419L12 3.904Z",
    fill: "currentColor"
  })));
};
export default SvgStar;